import { Link } from "react-router-dom";
import { BrandMark, BrandWordmark } from "./BrandLogo";
import { SiteFooter } from "./SiteFooter";
import { usePageMeta } from "../lib/usePageMeta";

export const ContactEmail = ({ email = "paul@getenquiryops.com" }) => (
  <a
    href={`mailto:${email}`}
    className="font-medium text-accent hover:underline rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]"
    data-testid="contact-email-link"
  >
    {email}
  </a>
);

export const LegalLayout = ({ title, description, heading, updated, children }) => {
  usePageMeta(title, description);
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="sticky top-0 z-50 bg-background border-b border-border">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-1.5 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] focus-visible:ring-offset-2"
            aria-label="EnquiryOps home"
            data-testid="legal-nav-logo"
          >
            <BrandMark size={32} />
            <BrandWordmark className="text-lg" />
          </Link>
          <Link
            to="/"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]"
            data-testid="legal-back-to-site"
          >
            Back to site
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-semibold text-foreground" data-testid="legal-page-heading">{heading}</h1>
        <p className="text-xs text-muted-foreground mt-2">Last updated: {updated}</p>
        <div className="mt-8 space-y-8">{children}</div>
      </main>

      <SiteFooter />
    </div>
  );
};

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="text-lg font-semibold text-foreground mb-2">{title}</h2>
    <div className="text-sm text-muted-foreground leading-relaxed space-y-2">{children}</div>
  </section>
);
